'use strict';

module.exports = FormData;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/FormData.js
// module id = 822
// module chunks = 1